import { TableUIProvider } from "../../../contexts/TableUIContext";
import Salaries from "./Salaries";

export default function SalariesWrapper() {
    return (
        <TableUIProvider>
            <Salaries />
        </TableUIProvider>
    );
}
